import { DefaultAllowedTags } from '@tableau/widgets';
import * as DOMPurify from 'dompurify';

/* Set up sanitize options for use with textile */
const defaultOptions: DOMPurify.Config = {
  ALLOWED_TAGS: [...DefaultAllowedTags],
  // Returning TrustedHTML enables support for content security policies like this:
  // "require-trusted-types-for 'script'; trusted-types dompurify"
  RETURN_TRUSTED_TYPE: true,
  FORBID_ATTR: ['style']
};

export function sanitize(untrustedHtml: string, config?: DOMPurify.Config): string {
  // Note that opening links in a new tab is defined in MarkupField.tsx, so we don't need to add that hook here

  if (!untrustedHtml) {
    return '';
  }

  const sanitized = DOMPurify.sanitize(untrustedHtml, { ...defaultOptions, ...config }) as string;
  return sanitized.toString();
}

export type ISanitizer = typeof sanitize;
